import { render, staticRenderFns } from "./tips-wrap.vue?vue&type=template&id=491e7d2a&scoped=true&"
import script from "./tips-wrap.vue?vue&type=script&lang=js&"
export * from "./tips-wrap.vue?vue&type=script&lang=js&"
import style0 from "./tips-wrap.vue?vue&type=style&index=0&id=491e7d2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491e7d2a",
  null
  
)

export default component.exports